export enum AppPermissionStatus {
    GRANTED = 'granted',
    DENIED = 'denied',
    DENIED_CAMERA = 'denied-camera',
    DENIED_MOTION = 'denied-motion',
    PROMPT = 'prompt'
  }

export type PermissionDeniedType = "camera" | "motion";
 
  